import React, { Suspense } from "react";
import Spinner from "../lib/spinner";
const Quill = React.lazy(() => import("./quill_component"));

const QuillEditorWrapper = props => {
  return (
    <Suspense fallback={<Spinner isLoading />}>
      <Quill {...props} />
    </Suspense>
  );
};

export default QuillEditorWrapper;
